export default "__VITE_ASSET__Dqnbuhi$__"